import { graphql } from "gatsby"
import { GatsbyImage } from "gatsby-plugin-image"
import React from "react"
import { Container, Jumbotron, Row, Col } from "react-bootstrap"
import "bootstrap/dist/css/bootstrap.min.css"
import * as styles from "./page.module.scss"
import Layout from "../components/Layout"
import Seo from "../components/seo"

const pageFromGDocs = ({
  data: {
    page: {
      name,
      author,
      cover,
      childMarkdownRemark: { html },
      description,
      coverFocus,
    },
  },
}) => {
  const pageTitle = name
  return (
    <Layout>
      <Seo title={pageTitle} description={description} />
      <Jumbotron style={{ backgroundColor: `#fff`, padding: `0` }}>
        {cover && (
          <GatsbyImage
            image={cover.image.childImageSharp.gatsbyImageData}
            alt={cover.alt}
            title={cover.title}
            style={{
              height: `424px`,
              display: `flex`,
              justifyContent: `center`,
              marginBottom: `15px`,
            }}
            imgStyle={{ objectPosition: coverFocus }}
          />
        )}
        <h1 style={{ textAlign: `center`, marginBottom: `15px` }}>
          {pageTitle}
        </h1>
        <h3 className="author" style={{ textAlign: `center`, color: `#000` }}>
          By {author}
        </h3>
      </Jumbotron>
      <Container className={styles.page}>
        <Row>
          <Col md={{ span: 8, offset: 2 }} style={{ textAlign: `justify` }}>
            <div dangerouslySetInnerHTML={{ __html: html }} />
          </Col>
        </Row>
      </Container>
    </Layout>
  )
}

export const pageQuery = graphql`
  query Page($path: String!) {
    page: googleDocs(slug: { eq: $path }) {
      name
      author
      coverFocus
      cover {
        alt
        title
        image {
          childImageSharp {
            gatsbyImageData(placeholder: BLURRED, formats: [AUTO, WEBP, AVIF])
          }
        }
      }
      childMarkdownRemark {
        html
      }
      description
    }
  }
`

export default pageFromGDocs
